// Color primitives based on Vulcan design system
export const NEUTRAL = {
  900: '#202020',
  800: '#404040',
  700: '#606060',
  600: '#818181',
  500: '#A1A1A1',
  400: '#B4B4B4',
  300: '#C6C6C6',
  200: '#D9D9D9',
  100: '#ECECEC',
  50: '#F8F8F8',
  0: '#FFFFFF',
} as const

export const BLUE = {
  900: '#061470',
  800: '#0B1E88',
  700: '#112CA9',
  600: '#193CCA',
  500: '#234FEB',
  400: '#577DF3',
  300: '#799BF9',
  200: '#A6BFFD',
  100: '#D2E0FE',
} as const

export const GREEN = {
  900: '#075A3F',
  800: '#0B6D43',
  700: '#12874A',
  600: '#1BA14E',
  500: '#25BC50',
  400: '#55D66D',
  300: '#79EA83',
  200: '#A9F8A8',
  100: '#D7FBD3',
} as const

export const ORANGE = {
  900: '#783302',
  800: '#924504',
  700: '#B55E07',
  600: '#D87A0A',
  500: '#FC990F',
  400: '#FDBA4A',
  300: '#FECE6E',
  200: '#FEE29E',
  100: '#FEF2CE',
} as const

export const RED = {
  900: '#670125',
  800: '#7D0222',
  700: '#9B041E',
  600: '#B90616',
  500: '#D80909',
  400: '#E74F41',
  300: '#F37F67',
  200: '#FBB39A',
  100: '#FDDDCC',
} as const

export const YELLOW = {
  900: '#79640C',
  800: '#937C14',
  700: '#B69D20',
  600: '#DAC02E',
  500: '#FEE440',
  400: '#FEEC6F',
  300: '#FEF28C',
  200: '#FEF7B2',
  100: '#FEFBD8',
} as const

export const AQUA = {
  900: '#004275',
  800: '#015B8D',
  700: '#027FAF',
  600: '#02A9D1',
  500: '#04D8F4',
  400: '#41F1F8',
  300: '#67FBF5',
  200: '#9AFDF1',
  100: '#CCFEF4',
} as const

export const PURPLE = {
  900: '#171C7A',
  800: '#262D93',
  700: '#3D45B7',
  600: '#5862DB',
  500: '#7684FF',
  400: '#93A1FF',
  300: '#B0BEFF',
  200: '#CCDAFF',
  100: '#E9F7FF',
} as const